/* eslint-disable react/no-unknown-property */
import {
  GridStackOptions,
  GridStack as GridStackType,
  GridStackWidget,
  GridStack as GS,
} from 'gridstack';
import 'gridstack/dist/gridstack.css';
import { createRef, RefObject, useEffect, useRef } from 'react';
import { BREAKPOINTS } from '@app/theme/themes';
import Box from '../Box';
import { gridStackStyles } from './styles';

const options: GridStackOptions = {
  float: true,
  animate: false,
  margin: 7.5,
  column: 36,
  cellHeight: 50,
  cellHeightUnit: 'px',
  disableDrag: true,
  disableResize: true,
  layout: 'list',
  columnOpts: {
    columnMax: 36,
    layout: 'none',
    breakpoints: [
      {
        w: parseFloat(BREAKPOINTS['mobile'].max),
        c: 1,
        layout: 'list',
      },
      {
        w: parseFloat(BREAKPOINTS['small'].max),
        c: 1,
        layout: 'list',
      },
    ],
  },
};

interface IGridStack {
  elements: GridStackWidget[];
}

const GridStack = ({ elements }: IGridStack) => {
  const grid = useRef<GridStackType | null>(null);
  const widgetsRefs = useRef<Record<string, RefObject<HTMLDivElement>>>({});
  const previousElements = useRef<GridStackWidget[]>([]);

  if (Object.keys(widgetsRefs.current).length !== elements.length) {
    elements.forEach(({ id }) => {
      if (!id) return;
      widgetsRefs.current[id] = widgetsRefs.current[id] || createRef();
    });
  }

  useEffect(() => {
    grid.current = grid.current || GS.init(options, '.gs-editor');

    if (widgetsRefs.current && grid.current) {
      grid.current.batchUpdate();
      grid.current.removeAll(false);
      grid.current.batchUpdate(false);
      elements.forEach(_element => {
        if (!_element.id) return;
        const widgetElement = widgetsRefs.current[_element.id]?.current;
        if (widgetElement) {
          grid.current?.makeWidget(widgetElement, _element);
        }
      });
      previousElements.current = elements;
      grid.current.batchUpdate(false);
    }
  }, [elements]);

  return (
    <Box
      className="grid-stack gs-editor"
      csx={gridStackStyles}
      style={{
        marginTop: '-2.5px',
        height: '100%',
      }}>
      {elements.map(element => (
        <div
          ref={widgetsRefs.current[element.id as string]}
          key={element.id}
          id={`widget-${element.id}`}
          className="grid-stack-item"
          gs-x={element.x}
          gs-y={element.y}
          gs-w={element.w}
          gs-h={element.h}
          style={{ cursor: 'default' }}>
          <div className="grid-stack-item-content noBorder">
            {element.content}
          </div>
        </div>
      ))}
    </Box>
  );
};

export default GridStack;
